module.exports = __webpack_public_path__ + "static/img/avatar_r_9.578987b2.png";